import { render, staticRenderFns } from "./daily.vue?vue&type=template&id=2b57e947&scoped=true&"
import script from "./daily.vue?vue&type=script&lang=js&"
export * from "./daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57e947",
  null
  
)

export default component.exports